import { type ReactNode } from 'react'

type CardVariant = 'elevated' | 'outlined' | 'flat'
type CardPadding = 'none' | 'sm' | 'md' | 'lg'

interface CardProps {
  variant?: CardVariant
  padding?: CardPadding
  hover?: boolean
  className?: string
  children: ReactNode
}

const variantStyles: Record<CardVariant, string> = {
  elevated: 'bg-white shadow-card',
  outlined: 'bg-white border border-gray-200',
  flat: 'bg-gray-50',
}

const paddingStyles: Record<CardPadding, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
}

export function Card({
  variant = 'elevated',
  padding = 'md',
  hover = false,
  className = '',
  children,
}: CardProps) {
  const baseStyles = 'rounded-card'
  const hoverStyles = hover ? 'transition-shadow hover:shadow-card-hover' : ''

  return (
    <div
      className={`${baseStyles} ${variantStyles[variant]} ${paddingStyles[padding]} ${hoverStyles} ${className}`.trim()}
    >
      {children}
    </div>
  )
}

interface CardHeaderProps {
  title: string
  action?: ReactNode
}

export function CardHeader({ title, action }: CardHeaderProps) {
  return (
    <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
      <h2 className="text-lg font-medium text-gray-900">{title}</h2>
      {action}
    </div>
  )
}

interface CardBodyProps {
  className?: string
  children: ReactNode
}

export function CardBody({ className = '', children }: CardBodyProps) {
  return <div className={`p-4 ${className}`.trim()}>{children}</div>
}
